import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CollapsedButton,
  CollapsedLabel,
  ContactButton,
  ContactDescription,
  Description,
  MinimizeButton,
  Panel,
  Title,
} from "./freeUpgradePrompt.styled";

interface Props {
  readonly visible: boolean;
}

const PRICING_URL = "https://simflexity.com/sv/priser";

/** Shows Free customers where to learn more about additional features. */
export const FreeUpgradePrompt = ({
  visible,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);

  if (!visible) return null;

  if (!isExpanded) {
    return (
      <CollapsedButton type="button" onClick={() => setIsExpanded(true)}>
        <CollapsedLabel>{t("Subscription.ExploreMoreFeatures")}</CollapsedLabel>
      </CollapsedButton>
    );
  }

  return (
    <Panel role="complementary" aria-labelledby="free-upgrade-prompt-title">
      <MinimizeButton
        type="button"
        aria-label={t("Subscription.MinimizePrompt")}
        onClick={() => setIsExpanded(false)}
      >
        <CustomIcon name="v2/cross" size="18px" color={ColorV2.Blue3} />
      </MinimizeButton>

      <Title id="free-upgrade-prompt-title">
        {t("Subscription.UpgradePromptTitle")}
      </Title>
      <Description>{t("Subscription.UpgradePromptDescription")}</Description>
      <ContactDescription>
        {t("Subscription.UpgradePromptContact")}
      </ContactDescription>

      <ContactButton
        href={PRICING_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("Subscription.IWantToKnowMore")}
      </ContactButton>
    </Panel>
  );
};
